import type { FireflyRuntime } from "@squide/firefly";
import { registerLazyI18nextInstance } from "@packages/core-client/i18n/registerLazyI18nextInstance.ts";

export const assistantI18NextInstanceKey = "assistant-domain";

export function initAssistantI18next(runtime: FireflyRuntime) {
    registerLazyI18nextInstance(runtime, assistantI18NextInstanceKey, {
        "en-US": async () => (await import("./en.ts")).en,
        "fr-CA": async () => (await import("./fr.ts")).fr
    });
}
